import PropTypes from 'prop-types';
import React from 'react';
import { css, cx } from 'emotion';
import { Card } from 'antd';
import Flexbox from 'flexbox-react';

/**
 * Renders a card for the home page.
 */
export default class HomePageCard extends React.Component {
    static propTypes = {
        iconClass: PropTypes.string,
        onClick: PropTypes.func,
        children: PropTypes.any,
        className: PropTypes.string
    };

    render() {
        const antCard = css`
            margin-bottom: 20px;
            .ant-card-body {
                padding: 14px;
                zoom: 1;
                box-shadow: 3px 3px 20px 0 rgba(0, 0, 0, 0.3);
                i.fa {
                    color: rgb(255, 127, 14);
                    margin-right: 15px !important;
                }
            }
        `;
        const fontAwesomeClass = cx(`fa ${this.props.iconClass} fa-2x`, css`margin-right: 15px;`);
        const className = this.props.className ? this.props.className : '';
        const childStyle = cx(css`font-weight: bold;`, className);
        return (
            <div onClick={this.props.onClick}>
                <Card hoverable className={antCard} size="small" style={{ width: 300 }}>
                    <Flexbox flexDirection="row" alignItems="center" marginLeft="40px;">
                        <i className={fontAwesomeClass} aria-hidden="true"/>
                        <div className={childStyle}>{this.props.children}</div>
                    </Flexbox>
                </Card>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/page/process-home/HomePageCard.js